import { Observable } from "rxjs";
import { BaseService } from "src/Shared/Services/Base.service";
import { SettingsApiUrls } from "../Tools/SettingsApiUrls";
import { ILeadTypeSetting } from "../Interfaces/ILeadTypeSetting";
import { IUser, IPagedResult } from "src/Shared/Interfaces";

class SettingsService extends BaseService {
  public getLeadTypes(): Observable<ILeadTypeSetting[]> {
    return this.http.get<ILeadTypeSetting[]>(SettingsApiUrls.LeadTypes);
  }

  public addOrUpdateLeadType(request: ILeadTypeSetting): Observable<string> {
    return this.http.post<string>(SettingsApiUrls.LeadTypes, request);
  }
  public setLeadTypeStatus(id: number, isActive: boolean): Observable<string> {
    const url = isActive
      ? SettingsApiUrls.ActivateLeadType(id)
      : SettingsApiUrls.DeactivateLeadType(id);

    return this.http.patch<string>(url, {});
  }

  public getUsers(request: any): Observable<IPagedResult<IUser>> {
    return this.http.post<IPagedResult<IUser>>(SettingsApiUrls.Users, request);
  }
}

export default new SettingsService();

